import React, { useEffect, useRef } from 'react';

type Props = {
  enabled: boolean;
  nextEvolutionId: string | null;
  onReachEnd: (nextId: string) => void;
};

/**
 * Sentinel no fim do conteúdo expandido: ao entrar na viewport, expande a evolução seguinte.
 */
const EvolutionTimelineScrollSentinel: React.FC<Props> = ({ enabled, nextEvolutionId, onReachEnd }) => {
  const ref = useRef<HTMLDivElement>(null);
  const firedForNextRef = useRef<string | null>(null);

  useEffect(() => {
    if (!enabled) firedForNextRef.current = null;
  }, [enabled]);

  useEffect(() => {
    if (!enabled || !nextEvolutionId || !ref.current) return;
    const el = ref.current;
    const nextId = nextEvolutionId;

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        if (firedForNextRef.current === nextId) return;
        firedForNextRef.current = nextId;
        onReachEnd(nextId);
      },
      { root: null, rootMargin: '0px 0px 96px 0px', threshold: 0 },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [enabled, nextEvolutionId, onReachEnd]);

  if (!enabled || !nextEvolutionId) return null;

  return (
    <div
      ref={ref}
      aria-hidden
      style={{ height: 1, width: '100%', marginTop: 4, pointerEvents: 'none' }}
    />
  );
};

export default EvolutionTimelineScrollSentinel;
